// extracted by mini-css-extract-plugin
module.exports = {"root":"root--VD6DJ","icon":"icon--4MHA+"};